// extracted by mini-css-extract-plugin
export default {"control":"schedule_control__dqTpf","Cancel":"schedule_Cancel__RAmE8"};